import { createContext } from 'react';

const SocketContext = createContext({
    socketspot: '',
    socketp2p: '',
    socketuser: '',
    socketlaunch: ''
});

export default SocketContext;